import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TournamentHomeComponent } from './tournament-home/tournament-home.component';
import { TournamentStandingsComponent } from './tournament-standings/tournament-standings.component';
import { ChipsModule, ProgressModule, TableModule, UtilsModule, SvgIconModule } from '@mtgame/ui';
import { RouterModule } from '@angular/router';
import { ROUTES } from './tournament.routes';
import { GamesSliderModule } from '../../shared/games-slider/games-slider.module';
import { TournamentEventsModule } from '../../shared/tournament-events/tournament-events.module';
import { SharedModule } from '@shared/shared.module';
import { TournamentPlayoffWidgetModule } from '../../shared/tournament-playoff-widget/tournament-playoff-widget.module';
import { TournamentStandingsModule } from '../../shared/tournament-standings/tournament-standings.module';

@NgModule({
  imports: [
    CommonModule,
    ChipsModule,
    TableModule,
    RouterModule.forChild(ROUTES),
    UtilsModule,
    SvgIconModule,
    GamesSliderModule,
    TournamentEventsModule,
    SharedModule,
    TournamentPlayoffWidgetModule,
    TournamentStandingsModule,
    ProgressModule,
  ],
  exports: [
    TournamentStandingsComponent
  ],
  declarations: [
    TournamentHomeComponent,
    TournamentStandingsComponent,
  ]
})
export class TournamentModule {}
